import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row w-100" }
const _hoisted_2 = { class: "card-body w-50" }
const _hoisted_3 = { class: "card-body w-50" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold form-label mb-7" }, " Attach any supporting documents (e.g., informed consent, surveys, instruments, interview questions, focus group questions, etc.) utilized. ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "mb-7" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, "Supporting Documents", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDownSection = _resolveComponent("DropDownSection")!
  const _component_Documents = _resolveComponent("Documents")!
  const _component_DocumentsRO = _resolveComponent("DocumentsRO")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DropDownSection, {
        title: "Review for more information",
        list: _ctx.listDropDownSections
      }, null, 8, ["list"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _createVNode(_component_Documents, {
        title: "1. Informed Consent ",
        hiddeDocuments: "true",
        classification: "Research-Activites",
        option: "Informed Consent",
        optionTarget: "#kt_modal_upload_file1"
      }),
      _createVNode(_component_Documents, {
        title: "2. Outcome Measures ",
        hiddeDocuments: "true",
        classification: "Research-Activites",
        option: "Outcome Measures",
        optionTarget: "#kt_modal_upload_file2"
      }),
      _createVNode(_component_Documents, {
        title: "3. Citi Training Certificates",
        hiddeDocuments: "true",
        classification: "Research-Activites",
        option: "CITI Training Certificate",
        optionTarget: "#kt_modal_upload_file3"
      }),
      _createVNode(_component_Documents, {
        title: "4. Other",
        option: "Other",
        hiddeDocuments: "true",
        classification: "Research-Activites",
        optionTarget: "#kt_modal_upload_file4"
      }),
      _createVNode(_component_DocumentsRO, {
        title: " ",
        option: "Other",
        hiddeDocuments: "false",
        classification: "Research-Activites",
        optionTarget: "#kt_modal_upload_file4"
      })
    ])
  ]))
}